import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../custom.css';
import Logo from './images/logo2.png';
import {requestPermission} from '../push-notifications';
//import { onUserLogin } from '../utils/serviceWorkerUtils';
import { updateUserInServiceWorker } from '../utils/serviceWorkerUtils';

function Login() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [showOtpFields, setShowOtpFields] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);
  const navigate = useNavigate();
 const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
 const [showModal, setShowModal] = useState(false);
const [modalMessage, setModalMessage] = useState('');
const [modalType, setModalType] = useState(''); // 'success', 'error', 'warning'
  // Add state for loading
   const [isLoading, setIsLoading] = useState(false);
   const [loadingMessage, setLoadingMessage] = useState('');
   const [timer, setTimer] = useState(0);


   useEffect(() => {
  let interval = null;
  if (timer > 0) {
    interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);
  }
  return () => {
    if (interval) clearInterval(interval);
  };
}, [timer]);

  useEffect(() => {
    const vendorDataString = localStorage.getItem('vendorData');

   if (vendorDataString) {
      try {
        // Parse the JSON string
        const vendorData = JSON.parse(vendorDataString);
        
        // Set vendorId and token in sessionStorage
        sessionStorage.setItem('vendorId', vendorData.id);
        sessionStorage.setItem('token', vendorData.token);
        localStorage.setItem('userId', vendorData.id);
        setIsLoading(true);
      
      // Function to fetch notifications and navigate
        const fetchNotificationsAndNavigate = async () => {
          try {
            
            const response = await fetch(
              `${fetchUrl}customer/quotations/get-live-order-notifications?userId=${vendorData.id}`,
              {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'x-token': vendorData.token,
                },
              }
            );

          const notificationData = await response.json();
          console.log('Notifications:', notificationData);


          if (notificationData.success && Array.isArray(notificationData.data)) {
            // Filter notifications with order status 'Respond Now' or 'Awarded'
            const eligibleNotifications = notificationData.data.filter(notification => 
             notification.metadata && 
                (notification.metadata.order_status === 'Respond Now' || 
                 notification.metadata.order_status === 'Awarded')
              );
            // Sort eligible notifications by most recent order date
            const sortedNotifications = eligibleNotifications.sort((a, b) => 
              new Date(b.metadata.order_date) - new Date(a.metadata.order_date)
            );

            // If there are eligible notifications, navigate to the most recent order
            if (sortedNotifications.length > 0) {
              const mostRecentNotification = sortedNotifications[0];
              navigate('/supplier/orderdetails', {
                state: {
                  quotationId: mostRecentNotification.metadata.order_id,
                  vendor_id: vendorData.id,
                  order_number: mostRecentNotification.metadata.order_number,
                  from: 'login'
                }
              });
            } else {
              // No eligible notifications, navigate to home
              navigate('/supplier/home');
            }
          } else {
            // No notifications or error in fetching, navigate to home
            navigate('/supplier/home');
          }
        } catch (error) {
          console.error('Error fetching notifications:', error);
          // Navigate to home in case of any error
          navigate('/supplier/home');
        } finally {
          setIsLoading(false);
        }
      };

      // Call the function to fetch notifications and navigate
      //  fetchNotificationsAndNavigate();
      } catch (parseError) {
        console.error('Error parsing vendor data:', parseError);
        // Clear invalid localStorage data
        localStorage.removeItem('vendorData');
        sessionStorage.removeItem('vendorId');
        sessionStorage.removeItem('token');
      }
    }
  }, [navigate, fetchUrl]);

  const handleMobileNumberChange = (e) => {
    // Only allow numbers and limit to 10 digits
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };


const handleSendOTP = async () => {
  if (mobileNumber.length !== 10) {
    setModalType('error');
    setModalMessage('Please enter a valid 10-digit mobile number');
    setShowModal(true);
  } else {
     try {
      const res = await fetch(`${fetchUrl}vendor/vendor-login`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mobile_number: mobileNumber }),
      });
      console.log(mobileNumber);
      const responseData = await res.json();
      console.log(responseData);
      if (responseData.status !== 200 && responseData.success === false) {
        setModalType('error');
        setModalMessage(responseData.message);
        setShowModal(true);
      }
      if (res.status == 200 && responseData.message === 'Login successful') {
      setShowOtpFields(true);
      setTimer(60); // Start timer after sending OTP
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }
};



  const handleOtpChange = (index, value) => {
    if (value.match(/^[0-9]?$/) || value === '') {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      // Auto-focus next input if value is entered
      if (value !== '' && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

 
// Updated handleVerifyOtp function
const handleVerifyOtp = () => {
  const otpValue = otp.join('');
  console.log("mobile,otp:",mobileNumber,otpValue)
  fetch(`${fetchUrl}vendor/verify-otp-and-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      mobile_number: mobileNumber,
      otp: otpValue
    }),
  })
    .then(response => {
      return response.json().then(data => ({
        status: response.status,
        data: data
      }));
    })
    .then(async ({ status, data }) => {
      console.log('Login response:', data);
      
      if (status === 200 && data.vendor_status === 3) {
        // Successful login only if vendor_status is 3 (approved)
        localStorage.setItem('vendorData', JSON.stringify({
          id: data._id,
          name: data.name,
          mobile_number: data.mobile_number,
          email: data.email,
          company_name: data.company_name,
          token: data.token,
          OrganizationId: data.organizationId,
          vendor_status: data.vendor_status
        }));

        sessionStorage.setItem('vendorId', data._id);
        sessionStorage.setItem('token', data.token);
        localStorage.setItem('userId', data._id );
        
        requestPermission();
        const userId = data._id;
        // Notify service worker about the user login
        updateUserInServiceWorker(userId);
         navigate('/supplier/home');
      
      } else if (status === 200 && data.vendor_status !== 3) {
        // Vendor not approved (vendor_status not 3)
        setModalType('warning');
        setModalMessage('Your account is pending approval. Please wait for admin approval before logging in.');
        setShowModal(true);
        
      } else if (status === 403) {
        setModalType('warning');
        if (data.message.includes('pending approval')) {
          setModalMessage('Your account needs approval from the admin before you can log in.');
        } else if (data.message.includes('under review')) {
          setModalMessage('Your account is under review. Please contact support for more information.');
        } else if (data.message.includes('inactive')) {
          setModalMessage('Your account has been deactivated. Please contact support.');
        } else {
          setModalMessage(data.message || 'Your account is not approved for login.');
        }
        setShowModal(true);
        
      } else if (status === 404) {
        setModalType('error');
        setModalMessage('No account found with this mobile number. Please register first.');
        setShowModal(true);
        
      } else {
        setModalType('error');
        setModalMessage(data.message || 'Login failed. Please try again.');
        setShowModal(true);
      }
    })
    .catch(error => {
      console.error('Error during login:', error);
      setModalType('error');
      setModalMessage('Network error. Please check your connection and try again.');
      setShowModal(true);
    });
};


 const handleResendOtp = async () => {
  try {
    const res = await fetch(`${fetchUrl}vendor/vendor-login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mobile_number: mobileNumber }),
    });
    console.log('Resending OTP to', mobileNumber);
    if (res.ok) {
      setTimer(60); // Reset timer on resend
    }
  } catch (error) {
    console.error('Error resending OTP:', error);
  }
};

  const handleBackToLogin = () => {
  setShowOtpFields(false);
  setOtp(['', '', '', '']);
  setTimer(0); 
  setMobileNumber('');
};

   const Loader = () => (
    <div className="fixed inset-0 bg-white bg-opacity-90 flex flex-col items-center justify-center z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#D64541] mb-4"></div>
      <p className="text-[#D64541] font-medium text-lg">{loadingMessage}</p>
    </div>
  );

  // If loading, show loader
  if (isLoading) {
    return <Loader />;
  }


  return (
    <div className="flex flex-col min-h-screen bg-[#F0EFEF]">
      {/* Logo Section - Increased padding to push login div down */}
      <div className="flex justify-center items-center pt-10 pb-8 flex-grow">
        <img
          src={Logo}
          alt="Company Logo"
          className="h-24 md:h-28"
        />
      </div>

      {/* Login Container - Decreased height with max-height and reduced padding */}
      <div className="bg-white rounded-t-3xl shadow-lg px-6 pt-6 pb-5 flex flex-col max-h-[55vh] relative">
        {/* Close Button for OTP Screen */}
        {showOtpFields && (
          <button 
            onClick={handleBackToLogin}
            className="absolute top-4 left-4 text-gray-500 hover:text-gray-700"
            aria-label="Back to login"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}

        {/* Login Header */}
        <h1 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          {showOtpFields ? 'Enter OTP' : 'Login'}
        </h1>

        {!showOtpFields ? (
          <>
            {/* Mobile Number Input */}
            <div className="mb-4">
              <label htmlFor="mobileNumber" className="block text-md font-semibold text-[#524D4D] mb-2">
                Mobile Number
              </label>
              <div className="flex">
                <div className="flex items-center justify-center bg-[#F6F4F4] px-3 border border-gray-300 border-r-0 rounded-l-md">
                  <span className="text-[#A8A1A1] font-medium">+91</span>
                </div>
                <input
                  type="tel"
                  id="mobileNumber"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                  placeholder="Enter your mobile number"
                  className="bg-[#F6F4F4] w-full px-4 py-3 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-[#D64541] focus:border-transparent"
                  maxLength="10"
                />
              </div>
            </div>

            {/* Send OTP Button */}
            <button
              onClick={handleSendOTP}
              className="w-full bg-[#D64541] text-white py-3 rounded-md font-medium hover:bg-opacity-90 transition duration-300 mb-4"
            >
              Send OTP
            </button>
          </>
        ) : (
          <>
            {/* OTP Verification Section */}
            <div className="mb-2 text-center">
              <p className="text-[#524D4D]">
                We've sent a verification code to
              </p>
              <p className="font-semibold text-[#524D4D]">
                +91 {mobileNumber}
              </p>
            </div>

            {/* OTP Input Fields */}
            <div className="flex justify-center gap-3 my-4">
              {otp.map((digit, index) => (
              <input
  key={index}
  id={`otp-${index}`}
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  value={digit}
  maxLength="1"
  className="w-12 h-12 text-center text-xl font-bold bg-[#F6F4F4] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#D64541] focus:border-transparent"
  onChange={(e) => {
    const onlyDigit = e.target.value.replace(/[^0-9]/g, "");
    handleOtpChange(index, onlyDigit);

    // Auto-focus next box
    if (onlyDigit) {
      const next = document.getElementById(`otp-${index + 1}`);
      if (next) next.focus();
    }
  }}
/>

              ))}
            </div>

            {/* Resend OTP */}
          <div className="text-center mb-4">
  {timer > 0 ? (
    <p className="text-sm text-[#827E7E] font-semibold">
      Didn't receive OTP? Resend in <span className="text-[#D64541] font-medium">{timer} seconds</span>
    </p>
  ) : (
    <button
      onClick={handleResendOtp}
      className="text-[#D64541] font-medium underline"
    >
      Resend OTP
    </button>
  )}
</div>

            {/* Verify OTP Button */}
            <button
              onClick={handleVerifyOtp}
              className="w-full bg-[#D64541] text-white py-3 rounded-md font-medium hover:bg-opacity-90 transition duration-300 mb-4"
            >
              Verify OTP
            </button>
          </>
        )}

        {/* Don't have an account */}
        <div className="text-center mt-auto pt-2">
          <p className="font-semibold text-[#827E7E]">
            Don't have an account?{' '}
            <span
              className="text-[#D64541] font-medium cursor-pointer underline"
              onClick={() => navigate('/supplier/register')}
            >
              Register
            </span>
          </p>
        </div>
      </div>


{showModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 mx-4 max-w-sm w-full">
      <div className="text-center">
        {modalType === 'success' && (
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        )}
        
        {modalType === 'warning' && (
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          </div>
        )}
        
        {modalType === 'error' && (
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
        )}
        
        <h3 className={`text-lg font-medium mb-2 ${
          modalType === 'success' ? 'text-green-800' : 
          modalType === 'warning' ? 'text-yellow-800' : 'text-red-800'
        }`}>
          {modalType === 'success' ? 'Success!' : 
           modalType === 'warning' ? 'Account Status' : 'Login Failed'}
        </h3>
        
        <p className="text-sm text-gray-600 mb-4">
          {modalMessage}
        </p>
        
      {modalType !== 'success' && (
  <button
    onClick={() => {
      if (modalType === 'warning') {
        handleBackToLogin();
      }
      setShowModal(false);
    }}
    className={`w-full py-2 px-4 rounded-md transition duration-300 ${
      modalType === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700 text-white' : 
      'bg-red-600 hover:bg-red-700 text-white'
    }`}
  >
    Back to Login
  </button>
)}

        
        {modalType === 'success' && (
          <div className="text-sm text-gray-500">
            Fetching User Details...
          </div>
        )}
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default Login;
